// extracted by mini-css-extract-plugin
module.exports = {"right":"styles_right__l3h9s"};